module.exports = __webpack_public_path__ + "img/erwei.35d0ffd4.png";